// extracted by mini-css-extract-plugin
export default {"subheader":"Subheader_subheader__U3hKl","content-wrapper":"Subheader_content-wrapper__31jak","segment":"Subheader_segment__RKq2U"};